let ENV = 'production'; // local | staging | production | preproduction
var Data = {};
if (window.location.hostname == 'localhost' || window.location.hostname == 'slomins.local') {
    ENV = 'local';
}
if (ENV == 'local' || ENV == 'staging') {
    Data = {
        API_BASEPATH: ENV == 'local' ? "http://auth.slomins.local/api" : 'https://authdevapi.slomins.com/api',
        Cookie_Domain: ENV == 'local' ? window.location.hostname : '.slomins.com',
        Cookie_Name: ENV == 'local' ? "auth_token_local" : 'auth_token_dev',
        Cookie_Secure: ENV == 'local' ? false : true,
        Cookie_SameSite: ENV == 'local' ? 'Strict' : 'None',
        Get365AuthApiUrl: "https://qa2.slomins.com/QA/Auth/1.0/Auth/GetAuthorizationUrl",
        Verify365AuthApiUrl: "https://qa2.slomins.com/QA/Auth/1.0/Auth/AuthenticationToken",
        Get365RedirectUri: ENV == 'local' ? "http://localhost:3000/login" : "https://oneportaldev.slomins.com/login",
    };
} else if (ENV == 'preproduction') {
    Data = {
        API_BASEPATH: "https://preauthapi.slomins.com/api",
        Cookie_Domain: ".slomins.com",
        Cookie_Name: 'auth_token_preprod',
        Cookie_Secure: true,
        Cookie_SameSite: 'None',
        Get365AuthApiUrl: "https://svcs.slomins.com/PROD/Auth/1.0/Auth/GetAuthorizationUrl",
        Verify365AuthApiUrl: "https://svcs.slomins.com/PROD/Auth/1.0/Auth/AuthenticationToken",
        Get365RedirectUri: "https://oneportal.slomins.com/login",
    };
} else {
    Data = {
        API_BASEPATH: "https://authapi.slomins.com/api",
        Cookie_Domain: ".slomins.com",
        Cookie_Name: 'auth_token_prod',
        Cookie_Secure: true,
        Cookie_SameSite: 'None',
        Get365AuthApiUrl: "https://svcs.slomins.com/PROD/Auth/1.0/Auth/GetAuthorizationUrl",
        Verify365AuthApiUrl: "https://svcs.slomins.com/PROD/Auth/1.0/Auth/AuthenticationToken",
        Get365RedirectUri: "https://oneportal.slomins.com/login",
    };
};
Data.ENV = ENV;

export const constant = Data;

// local http://oilinventoryapi.local/api
// dev https://oilinventoryapidev.slomins.com/api
// prod https://oilinventoryapi.slomins.com/api